/* Perito Moreno by Zoon Network · prices in the visitor's currency.
   The store sells in rupees only: Shopify charges other currencies only through Shopify Payments, which isn't offered in
   India. So for a visitor whose country (Shopify Markets: the "₹ INR" picker in the header) isn't India, every rupee price on
   the page is shown in their currency, "€203", at the day's rate (Perito Moreno Admin → /apps/mb/rates), the "₹ INR"
   labels and the picker show their currency, and the bag says what is charged at checkout ([data-pm-charge], kept in
   rupees). Without the day's rates nothing changes. Search engines and India always get rupees. */
(() => {
  'use strict';
  if (window.PM_CUR) return; window.PM_CUR = true;
  const CUR = {
    AE: 'AED', AT: 'EUR', AU: 'AUD', BD: 'BDT', BE: 'EUR', BG: 'EUR', BH: 'BHD', BN: 'BND', BR: 'BRL', CA: 'CAD', CH: 'CHF', CN: 'CNY',
    CY: 'EUR', CZ: 'CZK', DE: 'EUR', DK: 'DKK', EE: 'EUR', ES: 'EUR', FI: 'EUR', FR: 'EUR', GB: 'GBP', GR: 'EUR', HK: 'HKD', HR: 'EUR',
    HU: 'HUF', ID: 'IDR', IE: 'EUR', IL: 'ILS', IN: 'INR', IT: 'EUR', JP: 'JPY', KE: 'KES', KR: 'KRW', KW: 'KWD', LK: 'LKR', LT: 'EUR',
    LU: 'EUR', LV: 'EUR', MO: 'MOP', MT: 'EUR', MV: 'MVR', MX: 'MXN', MY: 'MYR', NG: 'NGN', NL: 'EUR', NO: 'NOK', NP: 'NPR', NZ: 'NZD',
    OM: 'OMR', PH: 'PHP', PL: 'PLN', PT: 'EUR', QA: 'QAR', RO: 'RON', SA: 'SAR', SE: 'SEK', SG: 'SGD', SI: 'EUR', SK: 'EUR', TH: 'THB',
    TR: 'TRY', TW: 'TWD', US: 'USD', VN: 'VND', ZA: 'ZAR'
  };
  const sym = c => { try { return new Intl.NumberFormat('en', { style: 'currency', currency: c, currencyDisplay: 'narrowSymbol' }).formatToParts(1).find(p => p.type === 'currency').value } catch (e) { return c } };
  /* the country picker lists each country with its own currency: "Romania (RON lei)" */
  const relabel = root => root.querySelectorAll('select[name="country_code"] option').forEach(o => {
    const c = CUR[o.value]; if (!c || o.dataset.pmCur) return; o.dataset.pmCur = c;
    o.textContent = o.textContent.replace(/\([A-Z]{3}\s[^)]*\)\s*$/, `(${c} ${sym(c)})`);
  });
  const tpl = document.getElementById('pm-country'); if (tpl) relabel(tpl.content);
  if (/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent)) return;
  const code = CUR[(window.Shopify && Shopify.country) || ''];
  if (!code || code === 'INR') return;

  const KEY = 'pm_rates', AGE = 6 * 3600e3;
  const cached = () => { try { const r = JSON.parse(localStorage.getItem(KEY) || 'null'); return r && Date.now() - r.at < AGE && r.rates ? r : null } catch (e) { return null } };
  const rates = () => cached() ? Promise.resolve(cached()) : fetch('/apps/mb/rates', { headers: { Accept: 'application/json' } })
    .then(r => r.ok ? r.json() : null)
    .then(d => { if (!d || !d.rates) return null; const r = { at: Date.now(), rates: d.rates }; try { localStorage.setItem(KEY, JSON.stringify(r)) } catch (e) { } return r })
    .catch(() => null);

  const SKIP = 'script,style,textarea,select,option,input,noscript,[data-pm-charge],[contenteditable],.ctry';
  const RX = /₹\s?(\d[\d,]*(?:\.\d{1,2})?)/g;
  const label = `${sym(code)} ${code}`;
  let rate = 0, fmt = null;
  const walk = (root, fn) => { const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT); let n; while ((n = w.nextNode())) fn(n) };
  const prices = n => {
    const v = n.nodeValue; if (!v || v.indexOf('₹') < 0) return;
    const p = n.parentElement; if (!p || p.closest(SKIP)) return;
    if (p.closest('[data-country]')) { if (/₹\s?INR/.test(v)) n.nodeValue = v.replace(/₹\s?INR/g, label); return }
    const out = v.replace(RX, (_, a) => fmt(Number(a.replace(/,/g, '')) * rate));
    if (out !== v) n.nodeValue = out;
  };
  const sweep = () => { walk(document.body, prices); document.querySelectorAll('[data-pm-charge]').forEach(e => { e.hidden = false }) };

  rates().then(r => {
    rate = r && r.rates[code]; if (!rate) return;
    const nf = [0, 2].map(d => new Intl.NumberFormat('en', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: d }));
    fmt = x => nf[x < 20 ? 1 : 0].format(x);
    sweep();
    /* the bag, the price of another size, anything the page adds later */
    let queued = false;
    new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; sweep() }) })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();
